module.exports = __webpack_public_path__ + "static/media/save-as-pdf.38403f61.svg";